module.exports = __webpack_public_path__ + "img/yuncheng-b3d3f3.png";